import OrderingDebtWarning from '@fingo/lib/components/ordering/OrderingDebtWarning';
import ChileActionButton from '@fingo/lib/components/buttons/ChileActionButton';
import { availableFactoringTitles } from '@fingo/lib/constants/factoring/summary-titles';
import { DISABLED_ROW_CLASS_NAME } from '@fingo/lib/theme/constants/data-grid';
import { THIRTY_DAYS_AGO, TODAY, formatDate } from '@fingo/lib/constants/dates';

const getWarningParams = (shoppingCartData) => ({
  orderingDebt: shoppingCartData?.orderingDebt,
  hasPurchaseOrdersNearToDebt: shoppingCartData?.hasPurchaseOrdersNearToDebt,
});

const isRowSelectable = ({ row }) => row.preofferSelectable?.selectable;

const getRowClassName = (row) => {
  if (!row.preofferSelectable?.selectable) {
    return DISABLED_ROW_CLASS_NAME;
  }
  return '';
};

const initialInvoiceFilters = {
  dateIssued_Gte: formatDate(THIRTY_DAYS_AGO),
  dateIssued_Lte: formatDate(TODAY),
  availableForFinancing: 'AVAILABLE',
  preoffer_Preofferevaluationrequest_Isnull: true,
};

const getStepsConditions = ({ selectedPreofferIds, showConfirmationSummary }) => [
  selectedPreofferIds.length === 0,
  showConfirmationSummary,
];

const OPTIONS = {
  initialOrderBy: '-folio',
  actionButtonComponent: ChileActionButton,
  warningAlertComponent: OrderingDebtWarning,
  summaryDataInfo: availableFactoringTitles.summaryDataInfoChile,
  showDocuments: false,
  getWarningParams,
  isRowSelectable,
  getRowClassName,
  initialInvoiceFilters,
  getStepsConditions,
  includeHeaders: [
    'folio',
    'dteType_Code',
    'dateIssued',
    'receiver_sortable',
    'amountWithIva',
    'preoffer_MonthlyRate',
    'factoringStatus',
  ],
  mobileHeaders: [
    'folio',
    'receiver_sortable',
    'preoffer_MonthlyRate',
    'amountWithIva',
  ],
  summaryHeaders: [
    'folio',
    'dateIssued',
    'receiver_sortable',
    'amountWithIva',
    'deleteDocument',
  ],
  summaryMobileHeaders: [
    'folio',
    'receiver_sortable',
    'amountWithIva',
    'deleteDocument',
  ],
};

export default OPTIONS;
